var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @flow
import React, { Component } from "react";
import BaseLayout from "templates/BaseLayout";
import HomeHeader from "molecules/HomeHeader";
var HomeLayout = /** @class */ (function (_super) {
    __extends(HomeLayout, _super);
    function HomeLayout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HomeLayout.prototype.render = function () {
        var _a = this.props, backgroundColor = _a.backgroundColor, children = _a.children;
        return (_jsx(BaseLayout, __assign({ backgroundColor: backgroundColor, topMenu: _jsx(HomeHeader, {}, void 0) }, { children: children }), void 0));
    };
    return HomeLayout;
}(Component));
export default HomeLayout;
